import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { edgeUsersApi } from '@/services/api/users-api'
import { edgeDataApi } from '@/services/api/data-api'
import { edgeResearchApi } from '@/services/api/research-api'
import { edgeBacktestApi } from '@/services/api/backtest-api'
import { edgeScriptApi } from '@/services/api/script-api'
import { BUILD } from '@/config/constants'
import { alertReducer } from '@/features/scanner/alerts/alert-store'

export const store = configureStore({
  reducer: {
    // RTK Query API slices
    [edgeUsersApi.reducerPath]: edgeUsersApi.reducer,
    [edgeDataApi.reducerPath]: edgeDataApi.reducer,
    [edgeResearchApi.reducerPath]: edgeResearchApi.reducer,
    [edgeBacktestApi.reducerPath]: edgeBacktestApi.reducer,
    [edgeScriptApi.reducerPath]: edgeScriptApi.reducer,
    alerts: alertReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(edgeUsersApi.middleware)
      .concat(edgeDataApi.middleware)
      .concat(edgeResearchApi.middleware)
      .concat(edgeBacktestApi.middleware)
      .concat(edgeScriptApi.middleware),

  devTools: BUILD.reduxLogging,
})

// Wires RTK Query's focus/online listeners — without this, per-endpoint
// `refetchOnReconnect` flags are inert. Panels whose polls are stateless
// (scanner) self-heal after an outage; ones that depend on a bootstrap query
// (watchlist → listWatchlists for ids) need that query to refetch when the
// connection returns or they stay stale forever.
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

if (import.meta.env.MODE !== 'production' && import.meta.env.MODE !== 'prod') {
  ;(window as unknown as { __alertStore__?: typeof store }).__alertStore__ = store
}
